import React from 'react';

const variants = {
  default: 'bg-gray-100 text-gray-700',
  primary: 'bg-primary-50 text-primary-700',
  success: 'bg-green-50 text-green-700',
  warning: 'bg-yellow-50 text-yellow-700',
  danger: 'bg-red-50 text-red-700',
  info: 'bg-blue-50 text-blue-700',
  purple: 'bg-purple-50 text-purple-700',
};

export const Badge = ({ children, variant = 'default', className = '', dot }) => {
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-xs font-medium rounded-full ${variants[variant]} ${className}`}>
      {dot && <span className={`h-1.5 w-1.5 rounded-full ${dot === true ? 'bg-current' : dot}`} />}
      {children}
    </span>
  );
};
